import VizWrapper from "@components/common/Base/VizWrapper";
import ImageRenderer from "@components/common/Image";
import Title from "@components/common/Title";
import {
  RelatedWhitepaperPropsModel,
  WhitePapersModel,
} from "@models/whitepaper";
import { Link } from "gatsby";
import React from "react";
import { FaChevronRight } from "react-icons/fa";

const RelatedWhitePapers: React.FunctionComponent<
  RelatedWhitepaperPropsModel
> = ({ componentData }) => {
  const { title, whitepapers } = componentData;

  const renderOneWhitePaper = (webinar: WhitePapersModel) => {
    const { title, image, slug } = webinar;
    const webinarDetailsRoute = `/whitepapers/${slug}`;
    return (
      <div className="bg-white w-[343px] sm:w-[200px] lg:w-[270px] p-[18px] shadow-lg rounded-2xl h-full relative flex flex-col">
        <div className="flex flex-col grow">
          <div className="rounded-lg overflow-hidden mb-4 aspect-video">
            <ImageRenderer image={image} className="h-full" />
          </div>
          <span className="block text-lg lg:text-xl mt-8 mb-10 line-clamp-4 max-h-[112px] text-ellipsis">
            {title}
          </span>
        </div>

        <Link to={webinarDetailsRoute} className="" target="_blank">
          <span className="flex items-center text-primary-blue-50 font-semibold [&>svg]:hover:translate-x-2 capitalize absolute bottom-4">
            VIEW WEBINAR <FaChevronRight />
          </span>
        </Link>
      </div>
    );
  };
  return (
    <VizWrapper style={{ backgroundColor: "#F0F3F6" }}>
      <Title variant="h2" titleText={title} className="text-center" />
      <div className="md:flex flex-wrap gap-6 justify-center">
        {whitepapers?.map((oneWhitepaper) => {
          return (
            <div
              key={oneWhitepaper?.id}
              className="flex justify-center my-4 md:my-4"
            >
              {renderOneWhitePaper(oneWhitepaper)}
            </div>
          );
        })}
      </div>
    </VizWrapper>
  );
};
export default RelatedWhitePapers;
